/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `FullscreenIconProps` interface defines the properties for the FullscreenIcon component.
 */
interface FullscreenIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "fullscreen" — outlined, weight 300.
 * Expand/fullscreen icon for zoom functionality.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const FullscreenIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'FullscreenIcon',
    width
}: FullscreenIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M200-200v-193h60v133h133v60H200Zm0-367v-193h193v60H260v133h-60Zm367 367v-60h133v-133h60v193H567Zm133-367v-133H567v-60h193v193h-60Z" />
    </svg>
);

FullscreenIcon.displayName = 'FullscreenIcon';